import {
  Button,
  Checkbox,
  Col,
  DatePicker,
  Form,
  message,
  Modal,
  Radio,
  Row,
  Select,
  Spin,
} from "antd";
import { CALL_API } from "common/API";
import { NON_EMPTY_REGEX, STATUS_CODE } from "common/Constants";
import dayjs from "dayjs";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { saveIsShowAgain } from "redux/actions";
import { getClientid, getIsShowAgain } from "redux/selectors";
import styled from "styled-components";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import weekday from "dayjs/plugin/weekday";
import localeData from "dayjs/plugin/localeData";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(weekday);
dayjs.extend(localeData);

const StyledModal = styled(Modal)`
  .box {
    background: #e3e8fc;
    border-radius: 5px;
  }
`;

const AssignShift = ({
  open,
  setOpen,
  selectedCell,
  shiftList,
  getAssignedShiftList,
  selectedRowIds,
  isMonthly,
  selectedCells = [],
  handleCancel = () => {},
  currentTime,
  userTimeZone,
  dataSource,
  selectedDate,
}) => {
  console.log("selectedDate-->", selectedDate);
  const ClientId = useSelector(getClientid);
  const getShowAgain = useSelector(getIsShowAgain);
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const containerRef = useRef(null);
  const [loader, setLoader] = useState(false);
  const [isDateCheckLoader, setIsDateCheckLoader] = useState(false);
  const [isShiftFound, setIsShiftFount] = useState(false);

  const restrictPastDate = (current, type) => {
    const fromDate = form.getFieldValue("fromdate");
    if (type === "todate") {
      return current && fromDate && current < moment(fromDate).startOf("day");
    }
    return current && current < moment().startOf("day");
  };

  const findShift = shiftList?.find(
    (val) => val?.shift_id === form.getFieldValue("shifttype")
  );

  const checkInBetweenDates = async () => {
    try {
      setIsDateCheckLoader(true);
      const payload = {
        clientId: ClientId,
        userId: selectedRowIds?.length
          ? selectedRowIds
          : [selectedCell?.userid],
        from: dayjs(form.getFieldValue("fromdate")).format("YYYY-MM-DD"),
        to: dayjs(form.getFieldValue("todate")).format("YYYY-MM-DD"),
      };
      const { assigned } = await CALL_API(
        `check-assigned-shift`,
        "post",
        payload
      );
      if (assigned === true || assigned === false) {
        setIsShiftFount(assigned);
      }
    } catch (error) {
      console.log("[onFinish] Error:", error);
    } finally {
      setIsDateCheckLoader(false);
    }
  };
  const currentDate = dayjs().tz(userTimeZone).format("YYYY-MM-DD");
  const shiftStartTime = dayjs(findShift?.starts).format("HH:mm:ss");
  console.log("datasource-->", dataSource);

  const selectedData =
    dataSource
      ?.filter((item) => selectedRowIds?.includes(item?.userid))
      ?.map(
        (item) => item?.[`${dayjs().tz(userTimeZone).format("YYYY-MM-DD")}`]
      ) || [];

  console.log("selecteddata-->", selectedData);

  const isInvalid =
    dayjs(form.getFieldValue("fromdate")).format("YYYY-MM-DD") ===
      currentDate && currentTime >= shiftStartTime;

  const filterSelectedCells = selectedCells.filter(
    (item) => item?.colKey === currentDate
  );

  const isInvalidSelectedCells =
    filterSelectedCells?.length > 0 && currentTime >= shiftStartTime;

  const onFinish = async (values) => {
    try {
      setLoader(true);
      const payload = {
        clientId: ClientId,
        userId:
          selectedCells?.length > 0
            ? []
            : selectedRowIds?.length
            ? selectedRowIds
            : [selectedCell?.userid],
        from: dayjs(values.fromdate).format("YYYY-MM-DD"),
        to: dayjs(values.todate).format("YYYY-MM-DD"),
        shift: values.shifttype,
        replaceExisting: values.replaceall || false,
        notifyByEmail: values.notifyemail || false,
        color: findShift?.color,
        userDateArray: selectedCells?.length > 0 ? selectedCells : [],
        localTimezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      };
      const response = await CALL_API(
        `assign-shift/${ClientId}`,
        "post",
        payload
      );
      if (
        response?.message === "Shift assigned successfully." ||
        response?.message === "Shift assignment completed."
      ) {
        getAssignedShiftList();
        message?.success("Shift assigned successfully");
        setIsShiftFount(false);
        form?.resetFields();
        setIsShiftFount(false);
        handleCancel();
      } else {
        message?.error("something went wrong");
      }
    } catch (error) {
      console.log("[onFinish] Error:", error);
    } finally {
      dispatch(
        saveIsShowAgain({ assignShift: form?.getFieldValue("assignshift") })
      );
      setLoader(false);
      setOpen(false);
    }
  };

  const showAssignConfirm = (values) => {
    if (getShowAgain?.assignShift) {
      onFinish(values);
    } else {
      Modal.confirm({
        title: "Are you sure you want to Assign this Shift?",
        content: (
          <Form
            form={form}
            name="isShowagain"
            layout="vertical"
            initialValues={{ assignshift: getShowAgain?.assignShift }}
          >
            <Form.Item name="assignshift" valuePropName="checked">
              <Checkbox
                disabled={false}
                style={{ color: "#5d5f68", fontWeight: 500 }}
              >
                Don't show this again
              </Checkbox>
            </Form.Item>
          </Form>
        ),
        okText: "Yes, Assign",
        cancelText: "No, Cancel",
        okButtonProps: {
          loading: loader,
        },
        onOk: async () => {
          onFinish(values);
        },
      });
    }
  };

  const fromDate = form?.getFieldValue("fromDate");
  const toDate = form?.getFieldValue("toDate");
  const dateRangeLength =
    fromDate && toDate ? toDate.diff(fromDate, "days") + 1 : 0;

  const handleWarning = () => {
    Modal.warning({
      title: "Shift assign not allowed",
      content:
        "You did not assign any shift for today, and the shift start time has already passed.",
      okText: "OK",
    });
  };

  useEffect(() => {
    if (selectedRowIds?.length > 0) {
      form.setFieldValue(
        "fromdate",
        isMonthly
          ? dayjs(selectedDate).isBetween(
              dayjs().startOf("month"),
              dayjs().endOf("month"),
              "day",
              "[]"
            )
            ? dayjs()
            : dayjs(selectedDate).startOf("month")
          : dayjs(selectedDate).isBetween(
              dayjs().startOf("week"),
              dayjs().endOf("week"),
              "day",
              "[]"
            )
          ? dayjs()
          : dayjs(selectedDate).startOf("week")
      );

      form.setFieldValue(
        "todate",
        isMonthly
          ? dayjs(selectedDate).endOf("month")
          : dayjs(selectedDate).endOf("week")
      );
      console.log("todate", dayjs(selectedDate).endOf("month"));
      checkInBetweenDates();
    } else if (selectedCell) {
      form.setFieldValue("fromdate", dayjs(selectedCell.date, "YYYY-MM-DD"));
      form.setFieldValue("todate", dayjs(selectedCell.date, "YYYY-MM-DD"));
    }
  }, [selectedRowIds, isMonthly, selectedCell, selectedDate]);

  return (
    <StyledModal
      title={
        <div className="d-flex justify-content-between align-items-center">
          <div>Assigning Shift</div>
          {selectedRowIds?.length > 0 && (
            <small className="mx-4" style={{ color: "#5d5f68" }}>
              Employee Chosen: <b>{selectedRowIds?.length}</b>
            </small>
          )}
          {selectedCells?.length > 0 && (
            <small className="mx-4" style={{ color: "#5d5f68" }}>
              Days Chosen: <b>{selectedCells?.length}</b>
            </small>
          )}
        </div>
      }
      open={open}
      onCancel={() => {
        setIsShiftFount(false);
        form?.resetFields();
        setIsShiftFount(false);
        handleCancel();
        setOpen(false);
      }}
      width={600}
      footer={[
        <Button
          key="cancel"
          onClick={() => {
            form.resetFields();
            setIsShiftFount(false);
            handleCancel();
            setOpen(false);
          }}
        >
          Cancel
        </Button>,
        <Button
          key="assign"
          type="primary"
          onClick={() => form.submit()}
          loading={loader}
        >
          Assign
        </Button>,
      ]}
    >
      <Spin spinning={isDateCheckLoader}>
        <div style={{ minHeight: "400px" }}>
          <Form
            form={form}
            name="assignShiftForm"
            layout="vertical"
            initialValues={{
              fromdate: selectedCell?.date
                ? dayjs(selectedCell.date, "YYYY-MM-DD")
                : null,
              todate: selectedCell?.date
                ? dayjs(selectedCell.date, "YYYY-MM-DD")
                : null,
            }}
            onFinish={(values) => {
              setOpen(false);
              if (
                selectedCells?.length === 0 &&
                selectedRowIds?.length === 0 &&
                isInvalid
              ) {
                handleWarning();
                return;
              } else if (
                selectedRowIds?.length > selectedData?.length &&
                isInvalid
              ) {
                handleWarning();
              } else if (selectedCells?.length > 0 && isInvalidSelectedCells) {
                handleWarning();
              } else {
                showAssignConfirm(values);
              }
            }}
          >
            <Row gutter={20}>
              {selectedCells?.length === 0 && (
                <>
                  <Col span={24} style={{ color: "#5d5f68", fontWeight: 500 }}>
                    Specify the date range
                  </Col>

                  <Col xs={24} md={12}>
                    <Form.Item
                      label="From"
                      name="fromdate"
                      rules={[
                        {
                          required: selectedCells?.length === 0 ? true : false,
                          message: "From date is required",
                        },
                        {
                          validator: (_, value) =>
                            value && dayjs(value).isValid()
                              ? Promise.resolve()
                              : Promise.reject("Invalid date"),
                        },
                      ]}
                    >
                      <DatePicker
                        format="DD-MM-YYYY"
                        className="w-100"
                        placeholder=""
                        disabledDate={(current) =>
                          restrictPastDate(current, "fromdate")
                        }
                        disabled={selectedRowIds?.length > 0 ? false : true}
                        getPopupContainer={() => containerRef.current}
                        onChange={(value) => {
                          const toDate = form.getFieldValue("todate");
                          if (toDate && value && dayjs(value).isAfter(toDate)) {
                            form.setFieldsValue({ todate: value });
                          }
                        }}
                      />
                    </Form.Item>
                  </Col>

                  <Col xs={12}>
                    <Form.Item
                      label="To Date"
                      name="todate"
                      rules={[
                        {
                          required: selectedCells?.length === 0 ? true : false,
                          message: "Please select To Date",
                        },
                      ]}
                    >
                      <DatePicker
                        format="DD-MM-YYYY"
                        style={{ width: "100%" }}
                        disabledDate={(current) =>
                          restrictPastDate(current, "fromdate")
                        }
                        onChange={checkInBetweenDates}
                      />
                    </Form.Item>
                  </Col>
                  {isShiftFound && (
                    <Col xs={24}>
                      <div className="box p-2 mb-2">
                        <Form.Item
                          label="This employee has shifts assigned on some days within the selected date range"
                          name="replaceall"
                          rules={[
                            {
                              required:
                                selectedCells?.length === 0 && isShiftFound
                                  ? true
                                  : false,
                              message: "Please select an option",
                            },
                          ]}
                        >
                          <Radio.Group>
                            <Radio value={true}>
                              Replace all with new shift
                            </Radio>
                            <Radio value={false}>
                              Only apply to unassigned day
                            </Radio>
                          </Radio.Group>
                        </Form.Item>
                      </div>
                    </Col>
                  )}
                </>
              )}

              <Col xs={24} sm={24} md={24} ref={containerRef}>
                <Form.Item
                  className="mb-2 pb-0"
                  label="Select a new shift to assign"
                  name="shifttype"
                  rules={[
                    {
                      required: true,
                      pattern: NON_EMPTY_REGEX,
                      message: "Shift type is required",
                    },
                  ]}
                >
                  <Select
                    showSearch
                    optionFilterProp="label"
                    placeholder="Select Shift"
                    options={
                      shiftList
                        ?.filter((item) => item?.status === "active")
                        ?.map((val) => {
                          return {
                            label: val?.shifttitle,
                            value: val?.shift_id,
                          };
                        }) || []
                    }
                    fieldNames={{
                      label: "label",
                      value: "value",
                    }}
                    // onChange={() => validateDateRange()}
                    getPopupContainer={() => containerRef.current}
                  />
                </Form.Item>
              </Col>
              {findShift && (
                <Col xs={24}>
                  <div className="box p-2">
                    <span style={{ color: "#5d5f68" }}>Timing</span>
                    <span className="mx-3">
                      {moment(findShift?.starts).format("hh:mm A")} -{" "}
                      {moment(findShift?.ends).format("hh:mm A")}
                    </span>
                  </div>
                </Col>
              )}

              <Col xs={24} className="mt-2">
                <Form.Item name="notifyemail" valuePropName="checked">
                  <Checkbox style={{ color: "#5d5f68", fontWeight: 500 }}>
                    Notify these employees regarding shift change through Email
                  </Checkbox>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </div>
      </Spin>
    </StyledModal>
  );
};

export default AssignShift;
